import { useState } from 'react';
import { generateItinerary } from '../services/openaiService';

export function useTrips() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createTrip = async (tripData) => {
    setLoading(true);
    setError(null);

    try {
      const itinerary = await generateItinerary({
        destination: tripData.destination,
        startDate: tripData.startDate,
        endDate: tripData.endDate,
        travelers: (tripData.adults || 2) + (tripData.children || 0),
        budget: tripData.budget,
        interests: tripData.interests
      });
      return itinerary;
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to create trip'));
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    createTrip,
    loading,
    error
  };
} 